import { render } from "./NonFungibleFutureRewards.vue?vue&type=template&id=b2070332&scoped=true"
import script from "./NonFungibleFutureRewards.vue?vue&type=script&lang=js"
export * from "./NonFungibleFutureRewards.vue?vue&type=script&lang=js"

import "./NonFungibleFutureRewards.vue?vue&type=style&index=0&id=b2070332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2070332"]])

export default __exports__